import React from "react"
import { useState } from "react"
import { requestJSON } from "../utils/request-module"
import { useLocalStorage } from "../utils/use-local-storage"

export default function ErcBalanceCheck(){
  var [blockNumber,set_blockNumber]=useLocalStorage('blockNumber','')
  var [owners,set_owners]=useLocalStorage('owners','')
  var [tokens,set_tokens]=useLocalStorage('tokens','')
  var [result,set_result]=useState('Please click submit')
  async function submit(){
    set_result('loadings...')
    try {
      var res=await requestJSON("POST","/check-erc-balance",{owners,tokens,blockNumber})
      console.log({res})
      set_result(res.result)
    } catch(err){
      set_result(String(err))
    }
  }
  return <div>
    <b>blockNumber:</b>
    <input  value={blockNumber} onChange={e=>set_blockNumber(e.target.value)} type="number"/>
    <br/>
    <b>Owner:</b>
    <textarea rows={10} value={owners} onChange={e=>set_owners(e.target.value)} css={`width:100%;`}/>
    <br/>
    <br/>
    <b>Tokens:</b>
    <textarea rows={10} value={tokens} onChange={e=>set_tokens(e.target.value)} css={`width:100%;`}/>
    <button onClick={submit}>Submit</button>
    <br/>
    <textarea value={result} disabled rows={10} css={`width:100%;`}/>
    </div>
}